import React from "react"
import PropTypes from "prop-types"

const FormattedDate = ({ classes, timestamp }) => {
  const date = new Date(timestamp)
  const formatted = Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
  return <span className={classes}>{formatted}</span>
}

FormattedDate.propTypes = {
  /** External styles  */
  classes: PropTypes.any,
  /** Unix timestamp from backend  */
  timestamp: PropTypes.number.isRequired,
}
export default FormattedDate
